import * as R from "ramda";

// Element -> Number
export function getOffsetTop(element) {
  if (!element) {
    return 0;
  }

  const { top } = element.getBoundingClientRect();
  const scrollTop = getScrollTop();
  return top + scrollTop;
}

// String -> Number
const getOffsetTopById = (id) => {
  try {
    return R.compose(
      (top) => top - getHeaderHeight() - 16, // magic number moves it just a bit below the top
      getOffsetTop,
      (id) => document.querySelector(`#${id}`),
      R.replace("#", ""),
    )(id);
  } catch (e) {
    // probably a bad id
  }
};

// cross browser schinanigans
export function getScrollTop() {
  return document.documentElement.scrollTop || document.body.scrollTop;
}

export function scrollTo(offset, callback) {
  if (typeof callback === "function") {
    // the page is taller than the contents
    if (document.body.scrollHeight >= document.documentElement.clientHeight) {
      const fixedOffset = offset.toFixed();
      const onScroll = function () {
        if (window.pageYOffset.toFixed() === fixedOffset) {
          window.removeEventListener("scroll", onScroll, { passive: true });
          callback();
        }
      };

      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    } else {
      callback();
    }
  }

  window.scroll({
    top: offset,
    left: 0,
    behavior: "smooth",
  });
}

// () -> Number
function getHeaderHeight() {
  const nav = document.querySelector(".js-global-header");
  const navPos = nav && window.getComputedStyle(nav).position;
  return nav && navPos === "sticky" ? nav.getBoundingClientRect().height : 0;
}

export function scrollToId(id, setFocus) {
  scrollTo(getOffsetTopById(id), () => {
    if (setFocus) {
      document.querySelector(id).focus();
    }
  });
}
